import { select } from 'd3';
import type { HierarchyPointNode, HierarchyPointLink, HierarchyNode, Selection } from 'd3';
import type { TreeNode, TreeData } from '../types';
import $ from 'jquery';

// function to split CamelCase
export function splitName(elem: string): string {
    const splitElem = elem
        .split(/(?=[A-Z])/)
        .map(function (p) {
            return p.charAt(0).toUpperCase() + p.slice(1);
        })
        .join(' ');
    return splitElem;
}

// determine the coordinates of an svg element
export function getBB(selection: Selection<SVGGElement, HierarchyPointNode<TreeNode>, SVGGElement, {}>) {
    selection.each(function (d: HierarchyPointNode<TreeNode>) {
        d.data.bbox = this.getBBox();
    });
}

// function to walk through all nodes
export function visit(
    parent: HierarchyPointNode<TreeNode> | TreeData | Function,
    visitFn: Function,
    childrenFn: Function
) {
    if (!parent) {
        return;
    }
    visitFn(parent);
    const children = childrenFn(parent);
    if (children) {
        const count = children.length;
        for (let i = 0; i < count; i++) {
            visit(children[i], visitFn, childrenFn);
        }
    }
}

export function childCount(levelWidth: number[], level: number, n: HierarchyNode<TreeNode>) {
    if (n.children && n.children.length > 0) {
        if (levelWidth.length <= level + 1) {
            levelWidth.push(0);
        }
        levelWidth[level + 1] += n.children.length;
        n.children.forEach(function (d) {
            childCount(levelWidth, level + 1, d);
        });
    }
}

// function to draw the links between the nodes
export function diagonal(d: HierarchyPointLink<TreeNode>): string {
    let nodeGroup: SVGSVGElement,
        width = 0;
    if (d.source.data.id) {
        nodeGroup = select<SVGSVGElement, TreeNode>('#n-' + d.source.data.id).node();
    }
    // get width of node group element to set path accordingly
    if (nodeGroup) {
        width = nodeGroup.getBBox().width;
    }
    const path =
        'M' + (d.source.y + width + 20) + ',' + d.source.x + 'H' + (d.target.y - 15) + 'V' + d.target.x + ('h' + 15);
    return path;
}

// function to animate the searched node
export function animateNode(node: HierarchyPointNode<TreeNode>): void {
    for (let i = 0; i < 3; i++) {
        $('#n-' + node.data.id + ' .node-text')
            .fadeTo(400, 0)
            .fadeTo(400, 1);
    }
}
